<template>
  <page-outline :title="$t('verifications.dtls')">
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div class="px-3" v-else>
        <b-row class="">
          <b-col cols="2" class="p-0">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <div v-if="companyItems.length > 0">
          <b-row class="title-label-blue">
            <span class="text-center mx-auto">{{$t('verifications.company_data')}}</span>
          </b-row>
          <b-row class="justify-content-start">
            <b-table
              class="table"
              :items="companyItems"
              :fields="scoreFields"
              :tbody-tr-class="rowClass">
              <template #cell(score)="data">
                <div class="text-center">
                  <i class="fa-light fa-xmark btn btn-icon btn-icon-red" v-if="data.value === 'KO'"></i>
                  <i class="fa-light fa-check btn btn-icon btn-icon-green" v-if="data.value === 'OK'"></i>
                </div>
              </template>
            </b-table>
          </b-row>
        </div>

        <div v-if="etabItems.length > 0" class="mt-3">
          <b-row class="title-label-blue">
            <span class="text-center mx-auto">{{$t('verifications.company_building_data')}}</span>
          </b-row>
          <b-row class="justify-content-start">
            <b-table
              class="table"
              :items="etabItems"
              :fields="scoreFields"
              :tbody-tr-td-class="rowClass">
              <template #cell(score)="data">
                <div class="text-center">
                  <i class="fa-light fa-xmark btn btn-icon btn-icon-red" v-if="data.value === 'KO'"></i>
                  <i class="fa-light fa-check btn btn-icon btn-icon-green" v-if="data.value === 'OK'"></i>
                </div>
              </template>
            </b-table>
          </b-row>
        </div>

        <div v-if="note">
          <b-row class="title-label-blue">
            <span class="text-center mx-auto">{{$t('common.comment_label')}}</span>
          </b-row>
          <b-row class="justify-content-start">
            <b-table hover bordered head-variant="light"
              class="resultsVerifications"
              :items="noteItems"
              :fields="noteFields">
            </b-table>
          </b-row>
        </div>

        <div :title="$t('verification.effective_bnf')"
          v-if="entity.getUBOs"  class="mt-3">
          <b-row class="title-label-blue">
            <span class="text-center mx-auto">{{$t('verification.effective_bnf')}}</span>
          </b-row>
          <b-row v-if="ubos.length" class="justify-content-start">
            <b-col sm="6" class="form-group"
              v-for="(ubo, index) in ubos" :key="index">
              <i class="fa-light fa-user" v-if="ubo.Type === 'PP'"></i>
              <i class="fa-light fa-building" v-if="ubo.Type === 'PM'"></i>
              {{ ubo.LastName }}
              {{ ubo.FirstName }}
              {{ ubo.PercentageDetention + '%' }}
            </b-col>
          </b-row>
        </div>

        <!-- <hr/>
        <form-accordion :title="'Derniers actes'">
          <b-row class="justify-content-start">
            <b-col sm="4" class="form-group">
              <p>Dépot n° 99999999 du 15/10/2021</p>
              <p>07/10/2021	STATUTS MIS A JOUR (19 pages)</p>
            </b-col>
            <b-col sm="2" class="form-group">
              <b-button round
                class="button-action milkyBlockBlack"
                @click="callInstitutionalSource('2017-07-06')">
                {{ 'Télécharger' }}
              </b-button>
            </b-col>
          </b-row>
        </form-accordion> -->

        <div v-if="verificationsItems.length > 0" :title="$t('verifications.verification_title')" :isTitleUpperCase="false" class="mt-3 p-0">
          <b-row class="title-label-blue">
            <span class="text-center mx-auto">{{$t('verifications.verification_title')}}</span>
          </b-row>
          <b-row class="justify-content-start">
            <b-table
              class="table"
              :items="verificationsItems"
              :fields="verificationsFields"
              :sort-by="'id'"
              :tbody-tr-td-class="rowClass">
              <template #cell(result)="data">
                <i class="fa-light fa-xmark btn btn-icon btn-icon-red" v-if="data.value === 'KO'"></i>
                <i class="fa-light fa-warning btn btn-icon btn-icon-orange" v-else-if="data.value === 'WARN'"></i>
                <i class="fa-light fa-circle-info btn btn-icon btn-icon-orange" v-else-if="data.value === 'INFO'"></i>
                <i class="fa-light fa-check btn btn-icon btn-icon-green" v-else></i>
              </template>
            </b-table>
          </b-row>
        </div>

        <b-row class="title-label-blue">
          <span class="text-center mx-auto">{{$t('verifications.stat_global')}}</span>
        </b-row>
        <b-row class="justify-content-start">
          <table class="table">
            <thead>
              <th width='20%'>{{ $t('verifications.desc') }}</th>
              <th width='20%'>{{ $t('verifications.stat_global') }}</th>
              <th width='40%'>{{ $t('verifications.action') }}</th>
            </thead>
            <tbody v-if="globalStatus==='1'">
              <td>{{ $t('verifications.stat_ok') }}</td>
              <td><i class="fa-light fa-check btn btn-icon btn-icon-green"></i></td>
              <td>
                <b-button
                  variant="primary" size="lg"
                  @click="createSupplier()">
                  <i class="fa-light fa-plus"></i>
                  {{ $t('verifications.add_supplier') }}
                </b-button>
              </td>
            </tbody>
            <tbody v-if="globalStatus==='3'">
              <td>{{ $t('verifications.stat_warn') }}</td>
              <td><i class="fa-light fa-warning btn btn-icon btn-icon-orange"></i></td>
              <td>
                <b-button
                  variant="primary" size="lg"
                  @click="createSupplier()">
                  <i class="fa-light fa-plus"></i>
                  {{ $t('verifications.add_supplier') }}
                </b-button>
              </td>
            </tbody>
            <tbody v-if="globalStatus==='4'">
              <td>{{ $t('verifications.stat_ko') }}</td>
              <td><i class="fa-light fa-xmark btn btn-icon btn-icon-red"></i></td>
              <td>
                <b-button
                  variant="primary" size="lg"
                  @click="createSupplier()">
                  <i class="fa-light fa-plus"></i>
                  {{ $t('verifications.add_supplier') }}
                </b-button>
              </td>
            </tbody>
          </table>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import spinner from '@/components/common/spinner.vue'
import {loadPage} from '@/helpers/routing'
import legalStatusList from '@/data/legalstatus.json'
import backButton from '@/components/common/backButton.vue'

import moment from 'moment'

import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'VerificationsDetailPage',
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': spinner,
    'back-button': backButton
  },
  props: ['id'],
  data () {
    return {
      activateSpinner: true,
      address: '',
      coreBusiness: '',
      coreBusinessCode: '',
      coreBusinessLabel: '',
      dateCreation: '',
      entity: {},
      firstName: '',
      lastName: '',
      legalForm: '',
      postalCode: '',
      siren: '',
      siret: '',
      socialReason: '',
      town: '',
      siren_given: '',
      siren_score: '',
      siret_given: '',
      siret_score: '',
      social_reason_given: '',
      social_reason_score: '',
      legal_form_given: '',
      legal_form_score: '',
      registration_date_given: '',
      registration_date_score: '',
      naf_code_given: '',
      naf_code_score: '',
      street_name_given: '',
      street_name_score: '',
      zipcode_given: '',
      zipcode_score: '',
      city_given: '',
      city_score: '',
      globalStatus: '',
      score_req: '',
      vatNumber: '',
      ubos: [],
      direction: '2',
      verify: false,
      verificationsFields: [
        { key: 'control', label: this.$t('verifications.cont'), thStyle: { width: '20%' } },
        { key: 'result', label: this.$t('verifications.result'), thStyle: { width: '20%' } },
        { key: 'details', label: this.$t('verifications.details'), thStyle: { width: '40%' } }
      ],
      verificationsItems: [],
      score_min: {},
      scoreFields: [
        { key: 'title', label: this.$t('verifications.cont'), thStyle: { width: '20%' } },
        { key: 'found', label: this.$t('verifications.found_data'), thStyle: { width: '20%' } },
        { key: 'given', label: this.$t('verifications.given_data'), thStyle: { width: '20%' } },
        { key: 'score', label: this.$t('verifications.result'), thStyle: { width: '10%' } }
      ],
      companyItems: [],
      etabItems: [],
      legalStatusList: legalStatusList,
      noteFields: [
        { key: 'title', label: this.$t('verifications.title'), thStyle: { width: '100px' } },
        { key: 'creation_date', label: this.$t('verifications.date'), thStyle: { width: '100px' } },
        { key: 'note', label: this.$t('verifications.comment'), thStyle: { width: '200px' } }
      ],
      noteItems: [],
      note: false
    }
  },
  created () {
    this.entity = this.$engine.services.suppliers.selectedEntity
    this.verify = this.entity.verify
    console.log(this.entity)
    this.getVerif()
  },
  methods: {
    getVerif () {
      console.log('id', this.id)
        this.$engine.services.verifications.update(
          2,
          0,
          0,
          {},
          this.id
        ).then( resp => {
          let request = []
          request = resp.data.KYCVerificationsHistory
          console.log('r', resp.data.KYCVerificationsHistory)
          this.details(request)
        })
    },
    details (entity) {
      this.entity = entity

      console.log('ent', entity)
      this.address = this.entity.StreetName
      // let addressElements = ['StreetNumber', 'StreetNumberRepetition', 'StreetType', 'StreetName']
      // for (let indexElement in addressElements) {
      //   let element = addressElements[indexElement]
      //   if (this.entity[element]) {
      //     if (this.address === '') {
      //       this.address += this.entity[element]
      //     } else {
      //       this.address += ' ' + this.entity[element]
      //     }
      //   }
      // }
      this.coreBusinessCode = this.entity.ActivityUnit || this.entity.NAFCode
      this.coreBusinessLabel = this.entity.ActivityLabel || this.entity.NAFLabel
      if (this.coreBusinessCode && this.coreBusinessLabel) {
        this.coreBusiness = this.coreBusinessLabel + ' (' + this.coreBusinessCode + ')'
      }
      this.dateCreation = this.entity.CreationDateUnit || this.entity.RegistrationDate
      this.firstName = this.entity.FirstName || this.entity.LegalRepresentativeFirstname
      this.lastName = this.entity.LastName || this.entity.LegalRepresentativeLastname
      this.legalForm = this.entity.LegalForm || this.entity.LegalCategory // || this.entity.LegalCategoryLabel
      this.legalForm += ' - ' + this.getLegalFormLabel(this.legalForm)
      this.postalCode = this.entity.PostalCode || this.entity.ZipCode
      this.siren = this.entity.SIRENUnit || this.entity.Siren
      this.siret = this.entity.SIRET || this.entity.Siret
      this.siren_given = this.entity.siren_given
      this.siren_score = this.entity.siren_score
      this.siret_given = this.entity.siret_given
      this.siret_score = this.entity.siret_score
      this.social_reason_given = this.entity.social_reason_given
      this.social_reason_score = this.entity.social_reason_score
      this.legal_form_given = this.entity.legal_form_given
      this.legal_form_score = this.entity.legal_form_score
      this.registration_date_given = this.entity.registration_date_given
      this.registration_date_score = this.entity.registration_date_score
      this.naf_code_given = this.entity.naf_code_given
      this.naf_code_score = this.entity.naf_code_score
      this.street_name_given = this.entity.street_name_given
      this.street_name_score = this.entity.street_name_score
      this.zipcode_given = this.entity.zipcode_given
      this.zipcode_score = this.entity.zipcode_score
      this.city_given = this.entity.city_given
      this.city_score = this.entity.city_score
      this.score_min = this.entity.score_min
      this.score_req= this.entity.score_req
      this.globalStatus = this.entity.Status || this.entity.GlobalStatus
      this.listNote()
      if (this.entity.Denomination) {
        this.socialReason = this.entity.Denomination
      } else if (this.entity.SocialReason) {
        this.socialReason = this.entity.SocialReason
      } else if (this.entity.UsualDenomination) {
        this.socialReason = this.entity.UsualDenomination
        if (this.entity.Sign1) {
          this.socialReason += ' (' + this.entity.Sign1 + ')'
        }
      } else if (this.entity.FirstName1 && this.entity.FirstName2) {
        this.socialReason = this.entity.FirstName1 + ' ' + this.entity.FirstName2
      } else {
        this.socialReason = ''
      }
      this.town = this.entity.TownName || this.entity.City
      if (this.entity.getUBOs) {
        this.callUBOinstitutionalSource('318334463')
      }
      if (!this.verify) {
        this.setControls()
        this.score()
      }
    },
    checkStatus (name, tab) {
      if (tab.score_req[name + '_req'] === '1') {
        if (tab.data[name + '_score'] !== '' && parseInt(tab.data[name + '_score']) < parseInt(tab.score_min[name])) {
          return false
        }
      }
      return true
    },
    listNote () {
      let that = this
      that.$engine.services.suppliers.getCustomData(
        this.siren
      )
      .then(resp => {
        resp.data.CustomData.forEach(item => {
          item.creation_date = moment(item.creation_date).format('DD/MM/yyyy HH:mm:ss')
        })
        that.makeList(resp.data.CustomData)
      })
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    makeList (tab) {
      if (tab.length > 0) {
        this.note = true
      }
      this.noteItems = tab
    },
    getLegalFormLabel (value) {
      var foundLabel = ''
      this.legalStatusList['FR'].map(legalStatus => {
        if (value === legalStatus.code) {
          foundLabel = legalStatus.label
        }
      })
      if (foundLabel === '') {
        foundLabel = value
      }
      return foundLabel
    },
    callInstitutionalSource (dateDepot) {
      let dateDepotGet = dateDepot.replaceAll('-', '')
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.entity.Siren,
        DocType: 'STATUS',
        DateDepotGet: dateDepotGet
      }
      this.$engine.services.suppliers.getDocumentFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          let linkSource = response.data.DocumentData
          let downloadLink = document.createElement('a')
          let fileName = response.data.DocumentName

          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    callUBOinstitutionalSource (siren) {
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      // let params = {
      //   Siren: siren,
      //   RepeatOnlyPP: '1',
      //   SaveDatabase: '0'
      // }
      let that = this
      that.ubos = [
        {
          Type: 'PP',
          LastName: 'COUSIN',
          FirstName: 'Valérie',
          PercentageDetention: '50'
        },
        {
          Type: 'PP',
          LastName: 'BONNET',
          FirstName: 'XAVIER',
          PercentageDetention: '50'
        }
      ]
      that.$f7.hidePreloader()
      // this.$engine.services.suppliers.getUBOFromInstitutionalSource(params)
      // .then(response => {
      //   if (response.status === 200) {
      //     that.$f7.hidePreloader()
      //     if (response.data.Beneficial != null) {
      //       that.ubos = response.data.Beneficial
      //     }
      //   }
      // })
      // .catch(error => {
      //   errorMessageAlert(error, that)
      // })
    },
    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.result === 'KO') {
          return 'table-danger'
        } else if (item.result === 'WARN' || item.result === 'INFO') {
          return 'table-warning'
        } else {
          return ''
        }
    },
    setControls () {
      let registreKO = false // temporaire
      for (var i = 0; i < this.entity.CodeList.length; i++) {
        let code = this.entity.CodeList[i].Code || this.entity.CodeList[i].code
        let details = this.entity.CodeList[i].Reason || this.entity.CodeList[i].reason
        if (details) {
          details = details.replace(/\. /g, '.\r\n')
          details = details.replace(/###/g, '\r\n\r\n')
        }
        if (code === '00000') {
          this.verificationsItems.push({ id: 0, control: this.$t('common.format_siren'), result: 'KO', details: details, _rowVariant: 'danger' })
        }

        if (code === '01001') {
          this.verificationsItems.push({ id: 1, control: this.$t('common.state_comp'), result: 'OK', details: details })
        } else if (code === '01000') {
          this.verificationsItems.push({ id: 1, control: this.$t('common.state_comp'), result: 'KO', details: details, _rowVariant: 'danger' })
        }

        if (code === '01011') {
          this.verificationsItems.push({ id: 2, control: this.$t('common.state_etab'), result: 'OK', details: details })
        } else if (code === '01010') {
          this.verificationsItems.push({ id: 2, control: this.$t('common.state_etab'), result: 'KO', details: details, _rowVariant: 'danger' })
        }


        if (code === '14001') {
          this.verificationsItems.push({ id: 3, control: this.$t('common.activity'), result: 'OK', details: details })
        } else if (code === '14000') {
          this.verificationsItems.push({ id: 3, control: this.$t('common.activity'), result: 'KO', details: details, _rowVariant: 'danger' })
        }

        if (code === '12001' || code === '12030') {
          this.verificationsItems.push({ id: 4, control: this.$t('common.legal_process'), result: 'OK', details: details })
        } else if (code === '12000') {
          this.verificationsItems.push({ id: 4, control: this.$t('common.legal_process'), result: 'WARN', details: details, _rowVariant: 'warning' })
        }

        if (code === '03001') {
          this.verificationsItems.push({ id: 5, control: this.$t('common.tva_val'), result: 'OK', details: details })
        } else if (code === '03000') {
          this.verificationsItems.push({ id: 5, control: this.$t('common.tva_val'), result: 'WARN', details: 'Le numéro de TVA intracommunautaire n\'a pas été trouvé', _rowVariant: 'warning' })
        }

        if (code === '10011' || code === '10021') {
          this.verificationsItems.push({ id: 6, control: this.$t('common.inscription'), result: 'OK', details: details })
        } else if (code === '10010' || code === '10020' || code === '10030') {
          registreKO = true
          this.verificationsItems.push({ id: 6, control: this.$t('common.inscription'), result: 'WARN', details: details, _rowVariant: 'warning' })
        }

        if (code === '11011') {
          this.verificationsItems.push({ id: 7, control: this.$t('common.available_stat'), result: 'OK', details: details })
        } else if (code === '11010') {
          this.verificationsItems.push({ id: 7, control: this.$t('common.available_stat'), result: 'WARN', details: details, _rowVariant: 'warning' })
        }

        if (code === '13001') {
          this.verificationsItems.push({ id: 8, control: this.$t('common.comp_stab'), result: 'OK', details: details })
        } else if (code === '13000') {
          this.verificationsItems.push({ id: 8, control: this.$t('common.comp_stab'), result: 'WARN', details: details, _rowVariant: 'warning' })
        }
      }
      if (registreKO) {
        this.verificationsItems = this.verificationsItems.filter(function (obj) {
          return obj.id !== 7
        })
      }
      this.activateSpinner = false
    },
    score () {
      this.companyItems.push({ title: this.$t('verifications.lblSIREN'), found: this.siren, given: this.siren_given, score: '' })
      this.companyItems.push({ title: this.$t('verifications.lblSocialReason'), found: this.socialReason, given: this.social_reason_given, score: '' })
      this.companyItems.push({ title: this.$t('common.dt_crtn'), found: this.dateCreation, given: this.registration_date_given, score: '' })
      this.companyItems.push({ title: this.$t('suppliers.legal_status'), found: this.legalForm, given: this.legal_form_given, score: '' })
      this.companyItems.push({ title: this.$t('suppliers.core_business'), found: this.coreBusiness, given: this.naf_code_given, score: '' })
      this.etabItems.push({ title: this.$t('verifications.lblSIRET'), found: this.siret, given: this.siret_given, score: '' })
      this.etabItems.push({ title: this.$t('common.adrs'), found: this.address, given: this.street_name_given, score: '' })
      this.etabItems.push({ title: this.$t('common.zp_code'), found: this.postalCode, given: this.zipcode_given, score: '' })
      this.etabItems.push({ title: this.$t('common.cty'), found: this.town, given: this.city_given, score: '' })

      if (Object.keys(this.score_min).length !== 0) {
        if (this.siren_score !== '' && parseInt(this.score_min.siren) > parseInt(this.siren_score)) {
          this.companyItems[0].score = 'KO'
          this.companyItems[0]._rowVariant = 'danger'
        } else if (this.siren_score !== '') {
          this.companyItems[0].score = 'OK'
        }
        if (this.social_reason_score !== '' && parseInt(this.score_min.social_reason) > parseInt(this.social_reason_score)) {
          this.companyItems[1].score = 'KO'
          this.companyItems[1]._rowVariant = 'danger'
        } else if (this.social_reason_score !== '') {
          this.companyItems[1].score = 'OK'
        }
        if (this.registration_date_score !== '' && parseInt(this.score_min.registration_date) > parseInt(this.registration_date_score)) {
          this.companyItems[2].score = 'KO'
          this.companyItems[2]._rowVariant = 'danger'
        } else if (this.registration_date_score !== '') {
          this.companyItems[2].score = 'OK'
        }
        if (this.legal_form_score !== null && parseInt(this.score_min.legal_form) > parseInt(this.legal_form_score)) {
          this.companyItems[3].score = 'KO'
          this.companyItems[3]._rowVariant = 'danger'
        } else if (this.legal_form_score !== '') {
          this.companyItems[3].score = 'OK'
        }
        if (this.naf_code_score !== '' && parseInt(this.score_min.naf_code) > parseInt(this.naf_code_score)) {
          this.companyItems[4].score = 'KO'
          this.companyItems[4]._rowVariant = 'danger'
        } else if (this.naf_code_score !== '') {
          this.companyItems[4].score = 'OK'
        }
        if (this.siret_score !== '' && parseInt(this.score_min.siret) > parseInt(this.siret_score)) {
          this.etabItems[0].score = 'KO'
          this.etabItems[0]._rowVariant = 'danger'
        } else if (this.siret_score !== '') {
          this.etabItems[0].score = 'OK'
        }
        if (this.street_name_score !== '' && parseInt(this.score_min.street_name) > parseInt(this.street_name_score)) {
          this.etabItems[1].score = 'KO'
          this.etabItems[1]._rowVariant = 'danger'
        } else if (this.street_name_score !== '') {
          this.etabItems[1].score = 'OK'
        }
        if (this.zipcode_score !== '' && parseInt(this.score_min.zipcode) > parseInt(this.zipcode_score)) {
          this.etabItems[2].score = 'KO'
          this.etabItems[2]._rowVariant = 'danger'
        } else if (this.zipcode_score !== '') {
          this.etabItems[2].score = 'OK'
        }
        if (this.city_score !== '' && parseInt(this.score_min.city) > parseInt(this.city_score)) {
          this.etabItems[3].score = 'KO'
          this.etabItems[3]._rowVariant = 'danger'
        } else if (this.city_score !== '') {
          this.etabItems[3].score = 'OK'
        }
      }
    },
    verifyCompany () {
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      let params = {
        siren: this.siren_given,
        siret: this.siret_given,
        social_reason: this.social_reason_given,
        registration_date: this.registration_date_given,
        naf_code: this.naf_code_given,
        legal_form: this.legal_form_given,
        street_name: this.street_name_given,
        zipcode: this.zipcode_given,
        city: this.city_given
      }
      this.$engine.services.verifications.verifyCompany(params)
      .then(response => {
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.entity.CodeList = response.data.controls
          this.siren_score = response.data.data.siren_score
          this.siret_score = response.data.data.siret_score
          this.social_reason_score = response.data.data.social_reason_score
          this.registration_date_score = response.data.data.registration_date_score
          this.naf_code_score = response.data.data.naf_code_score
          this.legal_form_score = response.data.data.legal_form_score
          this.street_name_score = response.data.data.street_name_score
          this.zipcode_score = response.data.data.zipcode_score
          this.city_score = response.data.data.city_score
          this.score_min = response.data.score_min
          this.score_req = response.data.score_req
          this.score()
          this.globalStatus = response.data.GlobalStatus
          // if (response.data.GlobalStatus === '1' && (Object.keys(this.score_min).length !== 0 && Object.keys(this.score_req).length !== 0)) {
          //   for (let property in this.score_min) {
          //     if (!this.checkStatus(property, response.data)) {
          //       this.globalStatus = '4'
          //     }
          //   }
          // }
          that.setControls()
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    createSupplier () {
      this.$f7.showPreloader(this.$i18n.t('loading.adding_supplier'))
      let that = this
      this.legalForm = this.entity.LegalForm || this.entity.LegalCategory || this.entity.LegalCategoryLabel

      that.$engine.services.suppliers.create({
        SellerIdentifier: '',
        SocialReason: this.socialReason,
        Name: this.lastName,
        LegalRepresentativeLastName: this.lastName,
        LegalRepresentativeFirstName: this.firstName,
        LegalForm: this.legalForm,
        Siren: this.siren,
        Siret: this.siret,
        Email: this.$engine.user.get().email_reference,
        StreetName: this.address,
        PostalCode: this.postalCode,
        TownName: this.town,
        ControlsMode: '0',
        CreateAccount: 0,
        Country: 'FR',
        NAFCode: this.coreBusinessCode + ' - ' + this.coreBusinessLabel,
        CreationDate: this.dateCreation,
        StepWorkflow: '1'
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200 || response.status === 201) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.supplier_added'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.$engine.services.suppliers.getSupplierInfo({
              IdSeller: response.data.IdSeller
            })
            .then(resp => {
              if (resp && resp.data && resp.data.Sellers && resp.data.Sellers.length) {
                that.$engine.services.suppliers.selectedSupplier = resp.data.Sellers[0]
            // that.$engine.services.suppliers.selectedSupplier = response.data
                loadPage(that, {url: '/suppliers/kycform/'})
              }
            })
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    checkScore (score, name) {
      if (score !== null && this.score_min[name] > score) {
        return 'red'
      } else {
        return 'green'
      }
    }
  }
}
</script>
